import { render, staticRenderFns } from "./FindSplint.vue?vue&type=template&id=12808401&"
import script from "./FindSplint.vue?vue&type=script&lang=js&"
export * from "./FindSplint.vue?vue&type=script&lang=js&"
import style0 from "./FindSplint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports